'use strict';

/**
 *
 * @name: socialIcons
 *
 */

function SocialIconsDirective($location, $rootScope, $timeout) {

  'ngInject';

  return {
    link: function(scope, element) {

      $rootScope.hasSocialShare = true;

      var rootWatchers = {};

      scope.addlocation = $location;

      rootWatchers.bWidth = $rootScope.$watch('bWidth', function() {

        updateShareOptionsPosition();
      });

      rootWatchers.showPersistentVideo = $rootScope.$watch('showPersistentVideo', function() {

        updateShareOptionsPosition();
      });

      var watchPost = scope.$watch('addlocation.path()', function(newVal) {

        if (newVal) {

          $timeout(function() {

            updateShareOptionsPosition();
          });
        }
      });

      var articleWrapper;
      var isArticle;
      var contentWrapper;
      var posTop;

      function updateShareOptionsPosition() {

        element.removeClass('hidden');
        posTop = (element.parent().height() - element.height()) / 2 + 54 + 46;

        // if ($rootScope.showPersistentVideo) {

        //   posTop = Math.max(posTop, 54 + 140);
        // }

        // element.css({
        //   top: posTop
        // });

        articleWrapper = element.closest('div[role="main"]').find('.single-article .article-content');
        isArticle = articleWrapper.length;

        if (isArticle) {

          contentWrapper = articleWrapper;
        } else {

          contentWrapper = $('.single-video-wrapper');
        }

        $(window).off('scroll.socialIcons');
        $(window).on('scroll.socialIcons', function() {

          if (contentWrapper.length) {

            element.toggleClass('hidden', posTop + element.height() + 5 > contentWrapper.offset().top + contentWrapper.outerHeight() - window.scrollY);
          }
        });
      }

      document.addEventListener('playerLoad', updateShareOptionsPosition);
      document.addEventListener('imgLoaded', updateShareOptionsPosition);

      scope.$on('$destroy', function() {
        $rootScope.hasSocialShare = false;
        watchPost();
        Object.keys(rootWatchers)
          .forEach(function(killWatcherKey) {

            rootWatchers[killWatcherKey]();
          });
        document.removeEventListener('playerLoad', updateShareOptionsPosition);
        document.removeEventListener('imgLoaded', updateShareOptionsPosition);
        $(window).off('scroll.socialIcons');
        element.find('*').remove();
        articleWrapper = null;
        isArticle = null;
        contentWrapper = null;
        posTop = null;
      });

      updateShareOptionsPosition();
    }
  };
}

export default SocialIconsDirective;



// WEBPACK FOOTER //
// ./app/components/nn-players/nn-social-icons/nn-social-icons.directive.js